<template>
	<div class="modal is-active">
		<div class="modal-background" @click="close"></div>
		<div class="modal-card">
			<header class="modal-card-head">
				<p class="modal-card-title">
					{{ $t("prepare-sign.sign-field") }}
				</p>
				<button class="delete" @click="close"></button>
			</header>
			<section class="modal-card-body">
				<UserSelect v-model="selectedUser" />
				<div class="field">
					<div class="control">
						<label class="checkbox mb-2">
							<input type="checkbox" v-model="addSignerName" />
							{{ $t("prepare-sign.add-signer-name") }}
						</label>
					</div>
				</div>
			</section>
			<footer class="modal-card-foot is-justify-content-flex-end">
				<button class="button" @click="send">
					<Icon
						name="fa-paper-plane"
						helperClass="has-text-primary"
					/>
					<span>{{ $t("prepare-sign.send") }}</span>
				</button>
			</footer>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import UserSelect from "../UserSelect.vue";

export default {
	name: "prepare-sign",
	components: {
		UserSelect,
	},
	data() {
		return {
			selectedUser: null,
			missingUser: false,
			addSignerName: false,
		};
	},
	computed: {
		...mapGetters("colaborativeBoard", ["getFileId"]),
	},
	methods: {
		close() {
			this.$emit("close");
		},
		send() {
			if (this.selectedUser === null) {
				this.missingUser = true;
			}
			this.missingUser = false;

			this.$emit("sendAction", {
				type: "sign",
				user: this.selectedUser,
				fileId: this.getFileId,
				addSignerName: this.addSignerName,
			});
		},
	},
};
</script>